/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum TimeOfDay {
  AM = "AM",
  PM = "PM",
}

export enum Service {
  AllServices = "AllServices",
  InvisalignService = "InvisalignService",
  HealthyMouthMovementService = "HealthyMouthMovementService",
}

export enum Pilot {
  AllPilots = "AllPilots",
  MottoPilot = "MottoPilot",
}

export enum PhoneType {
  Home = "Home",
  Mobile = "Mobile",
}

export enum DigitalVisitReasonEnum {
  Other = "Other",
  Dentures = "Dentures",
  BrokenToothToothPain = "BrokenTooth_ToothPain",
  ClearAligners = "ClearAligners",
  Emergency = "Emergency",
  Implants = "Implants",
  HealthyMouthMovement = "Healthy_Mouth_Movement",
}

export enum DayOfWeek {
  Sunday = "Sunday",
  Monday = "Monday",
  Tuesday = "Tuesday",
  Wednesday = "Wednesday",
  Thursday = "Thursday",
  Friday = "Friday",
  Saturday = "Saturday",
}

export enum Application {
  AspenDental = "AspenDental",
  Motto = "Motto",
}

export interface Address {
  /** @format int32 */
  id?: number;
  line1?: string | null;
  line2?: string | null;
  line3?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
}

export interface AddressApiResponse {
  /** @format int32 */
  id?: number;
  line1?: string | null;
  line2?: string | null;
  line3?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
}

export interface AddressWithZipCodeApiResponse {
  /** @format int32 */
  id?: number;
  line1?: string | null;
  line2?: string | null;
  line3?: string | null;
  city?: string | null;
  state?: string | null;
  zipCode?: string | null;
}

export interface Answer {
  answerCode?: string | null;
  answerDescription?: string | null;
  questionCode?: string | null;
  isExclusive?: boolean;
}

export interface AppointmentApiResponse {
  /** @format int64 */
  appointmentNumber?: number;
  /** @format double */
  visitNumber?: number;
  visitDescription?: string | null;
  /** @format date-time */
  dateTimeField?: string;
  patientName?: string | null;
  facilityCode?: string | null;
  /** @format int32 */
  duration?: number;
  confirmationStatus?: string | null;
  canReschedule?: boolean;
}

export interface AuthenticateApiRequest {
  username?: string | null;
  password?: string | null;
  apiKey?: string | null;
}

export interface AuthenticateApiResponse {
  firstName?: string | null;
  lastName?: string | null;
  username?: string | null;
  token?: string | null;
}

export interface BalanceResponse {
  /** @format double */
  patientBalance?: number;
  /** @format double */
  accountBalance?: number;
  financialClass?: string | null;
  /** @format double */
  insurancePendingBalance?: number;
  /** @format double */
  totalPatientFees?: number;
  /** @format double */
  totalResponsibility?: number;
  phoneNumber?: string | null;
  dateOfBirth?: string | null;
}

export interface ErrorResponse {
  errors?: string | null;
  errorCode?: string | null;
}

export interface NearByV3Response {
  timeslots?: SlotsSearchResponseV3[] | null;
  facilityCode?: string | null;
  title?: string | null;
  address?: AddressApiResponse;
  zipCode?: string | null;
  phone?: string | null;
  /** @format double */
  distance?: number;
  onHVP?: boolean;
}

export interface NearByV4Response {
  timeslots?: SlotsSearchResponseV4[] | null;
  facilityCode?: string | null;
  title?: string | null;
  address?: AddressApiResponse;
  zipCode?: string | null;
  phone?: string | null;
  /** @format double */
  distance?: number;
  onHVP?: boolean;
}

export interface OfficeApiResponse {
  code?: string | null;
  name?: string | null;
  address?: AddressApiResponse;
  phoneNumber?: string | null;
  firstThreeOctets?: string | null;
  legalBillingName?: string | null;
  onP3?: boolean;
  hasInvisalign?: boolean;
  onMotto?: boolean;
  /** @format date-time */
  openDate?: string | null;
}

export interface OfficeDetailByCodeApiResponse {
  address?: AddressWithZipCodeApiResponse;
  code?: string | null;
  name?: string | null;
  phoneNumber?: string | null;
  firstThreeOctets?: string | null;
  workingHours?: Record<string, string> | null;
  insurance?: OfficeInsuranceApiResponse[] | null;
  doctors?: OfficeDoctorApiResponse[] | null;
  landmarks?: string | null;
  services?: OfficeProcedurePriceApiResponse[] | null;
  dnis?: string | null;
  faxNumber?: string | null;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  neighboringAreas?: string | null;
  legalBillingName?: string | null;
  onP3?: boolean;
  hasInvisalign?: boolean;
  onMotto?: boolean;
  anytimeAppointingDenture?: boolean;
  anytimeAppointingMotto?: boolean;
  needsBasedQuestions?: boolean;
  /** @format date-time */
  openDate?: string | null;
  comingSoon?: boolean;
  /** @format int32 */
  minimumPatientAge?: number;
  implants?: string | null;
  birdeyeBusinessId?: string | null;
  dma?: string | null;
  timeZone?: string | null;
}

export interface OfficeDetailByCodeApiResponsePaginationResponse {
  /** @format int32 */
  currentPageNumber?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  items?: OfficeDetailByCodeApiResponse[] | null;
}

export interface OfficeDoctorApiResponse {
  providerId?: string | null;
  providerType?: string | null;
  npi?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  hireDate?: string;
  jobTitle?: string | null;
  gender?: string | null;
  employeeStatus?: string | null;
  active?: boolean;
  degreeName?: string | null;
  /** @format date-time */
  graduationDate?: string | null;
  collegeName?: string | null;
  collegeCity?: string | null;
  collegeState?: string | null;
  ethnicity?: string | null;
  associations?: string[] | null;
  languages?: string[] | null;
  biography?: string | null;
  specialties?: string | null;
  volunteerism?: string | null;
}

export interface OfficeInsuranceApiResponse {
  name?: string | null;
  /** @format int32 */
  id?: number;
}

export interface OfficeProcedurePriceApiResponse {
  formula?: string | null;
  procedureCategory?: string | null;
  procedureCode?: string | null;
  procedureDescription?: string | null;
  /** @format double */
  promotionalPrice?: number;
  /** @format double */
  ucfPrice?: number;
  activeFlag?: boolean;
  dentureFlag?: boolean;
  /** @format double */
  generalDentFee?: number;
  /** @format double */
  dentureFee?: number;
  dentureCouponCode?: string | null;
  generalDentistryCouponCode?: string | null;
}

export interface OfficeSearchApiResponse {
  facilityCode?: string | null;
  title?: string | null;
  address?: AddressApiResponse;
  zipCode?: string | null;
  phone?: string | null;
  /** @format double */
  distance?: number;
  onHVP?: boolean;
  legalBillingName?: string | null;
  onP3?: boolean;
  /** @format date-time */
  openDate?: string | null;
}

export interface OfficeSearchResponse {
  facilityCode?: string | null;
  title?: string | null;
  address?: Address;
  zipCode?: string | null;
  phone?: string | null;
  /** @format double */
  distance?: number;
  onHVP?: boolean;
  legalBillingName?: string | null;
  onP3?: boolean;
  /** @format date-time */
  openDate?: string | null;
}

export interface Person {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  /** @format date-time */
  dateOfBirth?: string;
  phoneNumber?: string | null;
  phoneType?: PhoneType;
  /** @format int64 */
  digiact?: number;
  /** @format int32 */
  age?: number;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface Question {
  questionCode?: string | null;
  questionDescription?: string | null;
  type?: string | null;
  answers?: Answer[] | null;
  triggers?: QuestionTrigger[] | null;
}

export interface QuestionnaireResponse {
  questionnaireCode?: string | null;
  questions?: Question[] | null;
}

export interface QuestionTrigger {
  questionCode?: string | null;
  parentQuestionCode?: string | null;
  parentQuestionAnswerCode?: string | null;
}

export interface RequestBody {
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  weekDays?: DayOfWeek[] | null;
  timeOfDay?: TimeOfDay;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  digitalVisitReason?: DigitalVisitReasonEnum;
  application?: Application;
  service?: Service;
  pilot?: Pilot;
  firstTimeDentureWearer?: boolean | null;
  email?: string | null;
  phone?: string | null;
  hasInsurance?: boolean | null;
  questionnaireAnsweredQuestions?: Record<string, string[]> | null;
}

export interface RescheduleApiRequest {
  /** @format int64 */
  accountNumber?: number;
  /** @format int64 */
  appointmentNumber?: number;
  slotId?: string | null;
}

export interface RescheduleSlotApiResponse {
  slotId?: string | null;
  time?: string | null;
}

export interface ScheduleAppointmentAccountResponse {
  accountNumber?: string | null;
  /** @format int64 */
  patientId?: number | null;
}

export interface ScheduleAppointmentRequestV2 {
  patient?: Person;
  insuranceFlag?: boolean;
  guardian?: Person;
  application?: Application;
  slotId?: string | null;
  questionnaireAnsweredQuestions?: Record<string, string[]> | null;
  questionnaireId?: string | null;
}

export interface ScheduleAppointmentResponse {
  accounts?: ScheduleAppointmentAccountResponse[] | null;
  appointmentNumber?: string | null;
}

export interface SlotsSearchRequestV6 {
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  facilityCode?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  dateOfBirth?: string | null;
  email?: string | null;
  phone?: string | null;
  hasInsurance?: boolean | null;
  digitalVisitReason?: DigitalVisitReasonEnum;
  questionnaireAnsweredQuestions?: Record<string, string[]> | null;
}

export interface SlotsSearchResponseV3 {
  slotId?: string | null;
  time?: string | null;
}

export interface SlotsSearchResponseV4 {
  slotId?: string | null;
  time?: string | null;
  /** @format int32 */
  patientTier?: number | null;
  /** @format int32 */
  nationalPatientTier?: number | null;
  /** @format double */
  patientValue?: number | null;
}

export interface SlotsSearchResponseV6 {
  slotId?: string | null;
  time?: string | null;
}

export interface ValidateAppointmentRequest {
  date?: string | null;
  facilityCode?: string | null;
  /** @format int32 */
  patientAge?: number;
  digitalVisitReason?: DigitalVisitReasonEnum;
  /** @format date-time */
  parsedDate?: string;
}

export interface ValidatePatientAccount {
  newPatient?: boolean;
  childPatient?: boolean;
  /** @format double */
  digiact?: number;
  accountNumber?: string | null;
  patientCode?: string | null;
}

export interface ValidatePatientResponseByPhoneV2 {
  multipleAccount?: boolean;
  accounts?: ValidatePatientAccount[] | null;
}

export interface ValidatePatientResponseWithScheduledAppointments {
  newPatient?: boolean;
  childPatient?: boolean;
  /** @format double */
  digiact?: number;
  hasScheduledAppointment?: boolean;
  /** @format date-time */
  appointmentTime?: string | null;
  facilityCode?: string | null;
  canSchedule?: boolean;
}

export interface ValidatePatientV3Account {
  newPatient?: boolean;
  childPatient?: boolean;
  patientCode?: string | null;
  /** @format double */
  accountNumber?: number;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  dateOfBirth?: string | null;
}

export interface ValidatePatientV3Response {
  multipleAccount?: boolean;
  accounts?: ValidatePatientV3Account[] | null;
}
